import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Action } from 'rxjs/internal/scheduler/Action';
import { environment } from '../../../environments/environment';
import { DropDownModel } from '../model/common/dropDownModel';
 

@Injectable({
  providedIn: 'root'
})
export class CommonServices {
  private baseUrl = `${environment.apiUrl}`;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'

    })
  };
  constructor(private http: HttpClient) {}

  getAllCountry(): Observable<DropDownModel[]> {
    return this.http.get<DropDownModel[]>(`${this.baseUrl}/location/country` ,  this.httpOptions);
  }


  getAllState(countryId: number): Observable<DropDownModel[]> {
    return this.http.get<DropDownModel[]>(`${this.baseUrl}/location/country/${countryId}/states`,  this.httpOptions);
  }

  /** Active tax jurisdictions (municipalities) for the property jurisdiction select. */
  getAppraiserOffices(): Observable<{ id: number; officeNumber: string; name: string }[]> {
    return this.http.get<{ id: number; officeNumber: string; name: string }[]>(`${this.baseUrl}/location/appraiser-offices`, this.httpOptions);
  }

  getAllJurisdictions(): Observable<JurisdictionOption[]> {
    return this.http.get<JurisdictionOption[]>(`${this.baseUrl}/location/jurisdictions`, this.httpOptions);
  }

}

export interface JurisdictionOption {
  id: number;
  name: string;
}
